var logger = require('../utils/logger.js');

var tcfVersion = 2;
var BauerVendorName = 'Bauer Media Group';

var eventNames = {
	uiShown: 'cmpuishown',
	userActionComplete: 'useractioncomplete',
	subsequentPageLoad: 'tcloaded'
};

	// Using ids instead of names as the usnat api does not provide vendor names
const vendorIds = {
	googleAdvertisingProducts: '5f1aada6b8e05c306c0597d7',
	covatic: '622b1a2a293cdf2be28075f2',
	permutive: '5f369a02b8e05c2f2d546a40',
	bauerMediaGroup: '5f8036e6145f6b2baf93e3d6'
};

// These values match those defined in the Vendor Management page on the Sourcepoint dashboard.
// Purposes have consistent preset names, while the IDs these names map to differ between vendor lists.
var purposeNames = {
	storeAndAccessInfo: 'Store and/or access information on a device',
	selectPersonalisedAds: 'Use profiles to select personalised advertising',
	createPersonalisedAdsProfile: 'Create profiles for personalised advertising'
};

function hasPurposeConsent(vendorConsents, purposeName) {
	if (!vendorConsents || !vendorConsents.consentedPurposes) {
		logger.warn('Vendor consent data is not set');
		return false;
	}

	return vendorConsents.consentedPurposes.some(function (purpose) {
			return purpose.name === purposeName;
		});
}

function hasVendorConsent(vendorConsents, vendorName) {
	if (!vendorConsents || !vendorConsents.consentedVendors) {
		logger.warn('Vendor consent data is not set');
		return false;
	}

	return vendorConsents.consentedVendors.some(function (vendor) {
		return vendor.name === vendorName;
	});
}

function addTcfApiHandler(eventStatus, callback) {
	window.__tcfapi('addEventListener', tcfVersion, function (tcData, success) {
		if (!success) {
			logger.warn('Failed to add tcf api handler');
			return;
		}

		if (tcData.eventStatus === eventNames.uiShown && eventStatus === eventNames.uiShown) {
			callback();
		}

		if (tcData.eventStatus === eventNames.userActionComplete && eventStatus === eventNames.userActionComplete) {
			callback();
		}

		if (tcData.eventStatus === eventNames.subsequentPageLoad && eventStatus === eventNames.subsequentPageLoad) {
			window.__tcfapi('removeEventListener', tcfVersion, function (success) {
				if (success) {
					callback();
				}
			}, tcData.listenerId);
		}
	});
}

function onRetrieveBauerConsent(successCallback, failureCallback) {
	window.__tcfapi('getCustomVendorConsents', tcfVersion, function (vendorConsents, success) {
		if (!success) {
			logger.warn('Failed to add bauer consent handler');
			return;
		}

		if (hasPurposeConsent(vendorConsents, purposeNames.storeAndAccessInfo) && hasVendorConsent(vendorConsents, BauerVendorName)) {
			successCallback();
		} else {
			failureCallback();
		}
	});
}

module.exports = {
	eventNames: eventNames,
	vendorIds: vendorIds,
	addTcfApiHandler: addTcfApiHandler,
	onRetrieveBauerConsent: onRetrieveBauerConsent,
};